import api from 'api/apiInstance';

export function adviceRoomCompleteApi(path: string) {
  return {
    path,
    POST: () => api.post(path),
  };
}
